module.exports = __webpack_public_path__ + "static/media/preview.d428547d.png";